export default __webpack_public_path__ + "4909de9edb855dea90057b635e332c46.png";